// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"HearStories_thecomp__b_5TZ"};